const HoursOfDayOptions = [
  {
    value: "0",
    key: "0",
    text: "12:00 AM",
  },
  {
    value: "1",
    key: "1",
    text: "01:00 AM",
  },
  {
    value: "2",
    key: "2",
    text: "02:00 AM",
  },
  {
    value: "3",
    key: "3",
    text: "03:00 AM",
  },
  {
    value: "4",
    key: "4",
    text: "04:00 AM",
  },
  {
    value: "5",
    key: "5",
    text: "05:00 AM",
  },
  {
    value: "6",
    key: "6",
    text: "06:00 AM",
  },
  {
    value: "7",
    key: "7",
    text: "07:00 AM",
  },
  {
    value: "8",
    key: "8",
    text: "08:00 AM",
  },
  {
    value: "9",
    key: "9",
    text: "09:00 AM",
  },
  {
    value: "10",
    key: "10",
    text: "10:00 AM",
  },
  {
    value: "11",
    key: "11",
    text: "11:00 AM",
  },
  {
    value: "12",
    key: "12",
    text: "12:00 PM",
  },
  {
    value: "13",
    key: "13",
    text: "13:00 PM",
  },
  {
    value: "14",
    key: "14",
    text: "14:00 PM",
  },
  {
    value: "15",
    key: "15",
    text: "15:00 PM",
  },
  {
    value: "16",
    key: "16",
    text: "16:00 PM",
  },
  {
    value: "17",
    key: "17",
    text: "17:00 PM",
  },
  {
    value: "18",
    key: "18",
    text: "18:00 PM",
  },
  {
    value: "19",
    key: "19",
    text: "19:00 PM",
  },
  {
    value: "20",
    key: "20",
    text: "20:00 PM",
  },
  {
    value: "21",
    key: "21",
    text: "21:00 PM",
  },
  {
    value: "22",
    key: "22",
    text: "22:00 PM",
  },
  {
    value: "23",
    key: "23",
    text: "23:00 PM",
  },
];

export default HoursOfDayOptions;
